<div class="page">
  <!-- Page Header-->
  <header class="section page-header jumbotron-classic">
    <!-- RD Navbar-->
    <div class="rd-navbar-wrap">
      <nav class="rd-navbar rd-navbar-classic" data-layout="rd-navbar-fixed" data-sm-layout="rd-navbar-fixed"
        data-md-layout="rd-navbar-fixed" data-md-device-layout="rd-navbar-fixed" data-lg-layout="rd-navbar-static"
        data-lg-device-layout="rd-navbar-fixed" data-xl-layout="rd-navbar-static"
        data-xl-device-layout="rd-navbar-static" data-xxl-layout="rd-navbar-static"
        data-xxl-device-layout="rd-navbar-static" data-lg-stick-up-offset="46px" data-xl-stick-up-offset="46px"
        data-xxl-stick-up-offset="46px" data-lg-stick-up="true" data-xl-stick-up="true" data-xxl-stick-up="true">
        <div class="rd-navbar-main-outer">
          <div class="rd-navbar-main">
            <!-- RD Navbar Panel-->
            <div class="rd-navbar-panel">
              <!-- RD Navbar Toggle-->
              <button class="rd-navbar-toggle" data-rd-navbar-toggle=".rd-navbar-nav-wrap"><span></span></button>
              <!-- RD Navbar Brand-->
              <div class="rd-navbar-brand">
                <a class="brand" [routerLink]="['/welcome']"><img class="brand-logo-dark"
                    src="assets/images/inversu-logotipo-transparente.png" alt="" width="143" height="26" /><img
                    class="brand-logo-light" src="assets/images/logo-inverse-286x52.png" alt="" width="143"
                    height="26" /></a>
              </div>

            </div>

            <div class="rd-navbar-search">
              <form class="form-layout-search form-lg rd-form rd-mailform form-filled form-inline form-inline_condensed"
                [formGroup]="searchFormGroup" (submit)="pesquisar()">
                <div class="form-wrap form-wrap-icon">
                  <input class="form-input" type="text" placeholder="{{'pesquisa_placeholder' | transloco}}"
                    formControlName="query">
                  <!-- <i class="icon fa-solid fa-tag"></i> -->
                  <a (click)="contextualSearch()" style="text-decoration:none;left:85%;">
                    <img src="assets/favicon.ico" width="20" height="20" alt="inversu" class="icone">
                  </a>
                  <a (click)="searchByBarcode()" style="text-decoration:none;left:85%;">
                    <i class="icon fa-solid fa-barcode" style="left:85%;"></i>
                  </a>
                  <a (click)="searchByPicture()" style="text-decoration:none;left:85%;">
                    <i class="icon fa-solid fa-camera" style="left:92%; cursor:pointer;"></i>
                  </a>
                </div>
                <div class="form-button">
                  <button class="button button-lg button-primary button-icon-only" type="submit" aria-label="search">
                    <i class="icon fa-solid fa-magnifying-glass fa-2xl"></i>
                  </button>
                </div>
              </form>
            </div>
            <div class="rd-navbar-main-element">
              <div class="rd-navbar-nav-wrap">
                <div class="top-nav">
                  <button type="button" label=""
                    class="button button-xs button-icon button-icon-left" (click)="toggle($event)">
                    <mat-icon class="material-symbols-outlined mr-2">list</mat-icon>
                    {{ 'menu.negociar' | transloco }}
                  </button>
                  <p-tieredmenu #menu [styleClass]="'top-menu-popup'" [model]="topNavItems" [popup]="true"
                    appendTo="body">

                    <!-- Template customizado para cada item -->
                    <ng-template pTemplate="item" let-item let-hasSubmenu="hasSubmenu">
                      <!-- Sem (click) próprio: o wrapper interno do PrimeNG
                        (`.p-tieredmenu-item-content`) já invoca `item.command`
                        ao capturar o clique que borbulha deste `<a>` — chamar
                        de novo aqui disparava o command 2x por clique (ex.:
                        "Lista de Compras" abria 2 modais de uma vez). -->
                      <a pRipple style="cursor: pointer;" class="d-flex py-3 justify-content-between align-items-center p-menuitem-link"
                        [ngClass]="{'p-disabled': item.disabled}">

                        <!-- <span [class]="item.icon" class="p-menuitem-icon"></span> -->
                        <span class="ml-2 fs-1">{{ item.labelKey | transloco }}</span>
                        <!-- ← aqui usa o pipe -->

                        <i *ngIf="hasSubmenu" class="ml-1 pi pi-angle-right ml-auto"></i>
                      </a>
                      <hr :key="item.labelKey" />
                    </ng-template>

                  </p-tieredmenu>

                  <!-- Alternativa: se quiser um Menubar horizontal no topo -->
                  <!--
<p-menubar [model]="topNavItems"></p-menubar>
-->

                  <!-- Ou se quiser popup / dropdown clássico -->
                  <!--
<p-menu #menu [model]="topNavItems" [popup]="true"></p-menu>
<button pButton label="Menu" (click)="menu.toggle($event)"></button>
-->
                </div>
                <!-- <ul class="rd-navbar-nav">
                  <ul class="whatever-navbar-nav">
                  <li class="rd-nav-item  ml-3" *ngFor="let menu of config?.top_nav | asArray">

                    <a class="rd-nav-link rd-link-navigate" *ngIf="menu.route && !menu.scroll" [routerLink]="menu.route"
                      [attr.data-rd-navbar-toggle]="menu.route ? '.rd-navbar-nav' : null">{{menu.label | transloco}}</a>
                    <a class="rd-nav-link rd-link-scroll" *ngIf="menu.route && menu.scroll" [attr.href]="menu.route"
                      [attr.data-rd-navbar-toggle]="menu.route ? '.rd-navbar-nav' : null">{{menu.label | transloco}}</a>
                    <a class="rd-nav-link rd-link-text" *ngIf="!menu.route" role="button"
                      (click)="navbarDropdownClick($event)">{{menu.label | transloco}}</a>

                    <ul class="rd-menu rd-navbar-dropdown" *ngIf="menu.children && menu.children.length > 0">
                      <li class="rd-nav-item" *ngFor="let menu of config?.top_nav | asArray">
                        <a class="rd-nav-link rd-link-navigate" *ngIf="menu.route && !menu.scroll"
                          [routerLink]="menu.route" [attr.data-rd-navbar-toggle]="menu.route ? '.rd-navbar-nav' : null">
                          {{ menu.label | transloco }}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul> -->
              </div>
            </div>

            <div class="rd-navbar-aside">
              <div class="rd-navbar-aside-item">
                <button mat-button [matMenuTriggerFor]="languageMenu" class="text-language">
                  <img [src]="currentLang.flag" height="24" width="24" class="mr-1">
                  <span class="hide-xs">{{ currentLang.label }}</span>
                </button>

                <mat-menu #languageMenu="matMenu">
                  <ng-container *ngFor="let lang of languages">
                    <button *ngIf="lang.code !== currentLang.code" mat-menu-item class="menu-item-custom"
                      (click)="trocarLingua(lang.code)">
                      <img [src]="lang.flag" height="24" width="24" class="mr-1">
                      {{ lang.label }}
                    </button>
                    <mat-divider *ngIf="lang.code !== currentLang.code"></mat-divider>
                  </ng-container>

                  <button mat-menu-item class="menu-item-custom d-flex justify-content-center">
                    <a class="w-100 text-center">{{'mais_idiomas' | transloco}}</a>
                  </button>
                </mat-menu>
              </div>
              <div class="rd-navbar-aside-item" *ngIf="!firebase.user">
                <button class="button button-xs button-primary-outline button-icon button-icon-left "
                  (click)="registro()"><span class="icon mdi mdi-account"></span>{{'registre_se' | transloco}}</button>

              </div>

              <div class="rd-navbar-aside-item" *ngIf="!firebase.user">
                <button type="button" class="button button-xs button-primary button-icon button-icon-left"
                  (click)="acesso()"><span class="icon mdi mdi-import"></span>{{'entrar' | transloco}}</button>
                <div class="rd-navbar-popup bg-gray-100" id="rd-navbar-login">
                  <app-acesso-cliente></app-acesso-cliente>
                </div>
              </div>
              <div class="rd-navbar-aside-item" *ngIf="firebase.user">
                <button type="button"
                  class="button button-xs button-primary-outline button-icon mat-button button-icon-left"
                  [matMenuTriggerFor]="accountTrigger"><span
                    class="icon mdi mdi-account"></span>{{toAbbreviateName(firebase.user?.displayName)}}
                </button>
                <mat-menu #accountTrigger="matMenu" xPosition="before">
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="minhaContaConfig()">
                    <mat-icon class="material-symbols-outlined">account_box</mat-icon>
                    {{'minha_conta' | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="minhaGaragemConfig()">
                    <mat-icon class="material-symbols-outlined">garage</mat-icon>
                    {{'garagem' | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom"
                    [matMenuTriggerFor]="subMenuNegotiations">
                    <mat-icon class="material-symbols-outlined">handshake</mat-icon>
                    {{ 'negociacoes' | transloco }}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="meusProdutos()">
                    <img src="../assets/images/icons/star.svg" alt="produtos" width="24" height="24" class="mr-1">
                    {{"produtos_texto" | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="categoriasProdutos()">
                    <img src="../assets/images/icons/star.svg" alt="categorias" width="24" height="24" class="mr-1">
                    {{"categorias" | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="meusFavoritos()">
                    <img src="../assets/images/icons/heart_smile.svg" alt="heart" width="24" height="24" class="mr-1">
                    {{ 'favoritos' | transloco }}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item class="menu-item-custom" (click)="sair()">
                    <img src="../assets/images/icons/logout.svg" alt="sair" width="24" height="24" class="mr-1">
                    {{ 'sair' | transloco }}
                  </button>
                </mat-menu>

                <mat-menu #subMenuNegotiations="matMenu" class="mx-1 mt-1">
                  <button type="button" mat-menu-item (click)="negociacoesAtivas()">
                    <img src="../assets/images/icons/assignment_turned_in.svg"
                      alt="{{'negociacoes_ativas' | transloco}}" width="24" height="24" class="mr-1">
                    {{"ativas" | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item (click)="negociacoesExpiradas()">
                    <img src="../assets/images/icons/times_off.svg" alt="negociações expiradas" width="24" height="24"
                      class="mr-1">
                    {{"expiradas" | transloco}}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item (click)="minhasCompras()">
                    <img src="../assets/images/icons/shopping_cart.svg" alt="compras" width="24" height="24"
                      class="mr-1">
                    {{ 'compras' | transloco }}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item (click)="minhasVendas()">
                    <img src="../assets/images/icons/package_2.svg" alt="vendas" width="24" height="24" class="mr-1">
                    {{ 'vendas' | transloco }}
                  </button>
                  <mat-divider></mat-divider>
                  <button type="button" mat-menu-item (click)="myNegotiationsBids()">
                    <img src="../assets/images/icons/currency_exchange.svg" alt="lances" width="24" height="24"
                      class="mr-1">
                    {{ 'lances' | transloco }}
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>

  <router-outlet></router-outlet>

  <footer class="section footer-creative context-dark">
    <div class="footer-creative-main">
      <div class="container">
        <div class="row row-50 justify-content-lg-between">
          <div class="col-lg-5 col-xl-4">
            <p class="footer-creative-title">{{'links_rapidos' | transloco}}</p>
            <div class="footer-creative-divider"></div>
            <div class="row row-narrow row-15">
              <div class="col-6">
                <ul class="list-marked-1">
                  <li><a [routerLink]="['/produtos']">{{'encontre_produto' | transloco}}</a></li>
                  <li><a [routerLink]="['/negociacoes']">{{'negociacoes' | transloco}}</a></li>
                  <li><a href="https://www.inversu.com.br/enviar-produtos" target="_blank">{{'enviar_alterar_produtos' |
                      transloco}}</a></li>
                  <li><a href="https://www.inversu.com.br" target="_blank">{{'corporativo' | transloco}}</a></li>
                </ul>
              </div>
              <div class="col-6">
                <ul class="list-marked-1">
                  <li><a href="https://www.inversu.com.br/investidores" target="_blank">{{'investidores' |
                      transloco}}</a></li>
                  <li><a href="https://www.inversu.com.br/vagas" target="_blank">{{'trabalhe_conosco' | transloco}}</a>
                  </li>
                  <li><a href="https://www.inversu.com.br/contato" target="_blank">{{'contato' | transloco}}</a></li>
                  <li><a href="https://www.inversu.com.br/ajuda" target="_blank">{{'perguntas_frequentes' |
                      transloco}}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 col-xl-3">
            <p class="footer-creative-title">{{'produtos_recentes' | transloco}}</p>
            <div class="footer-creative-divider"></div>
            <div class="post-line-group" *ngFor="let product of recentlyProducts | asArray">
              <a class="post-line" (click)="accessRecentlyProducts(product.link)">
                <time class="post-line-time" [attr.datetime]="product.year">
                  <span class="post-line-time-day">{{product.day}}</span>
                  <span class="post-line-time-month">{{product.month}}</span>
                </time>
                <p class="post-line-text">{{product.title}}</p>
                <!-- <p>{{recentlyProducts}}</p> -->
              </a>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <p class="footer-creative-title">{{'cidades_bem_negociadas' | transloco}}</p>
            <div class="footer-creative-divider"></div>
            <div class="row row-narrow row-15">
              <div class="col-6" *ngFor="let row of topCities">
                <ul class="list list-1 list-icons">
                  <li *ngFor="let city of row">
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>{{city}}</span>
                  </li>
                  <!-- <li>
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>Rio de Janeiro</span>
                  </li>
                  <li>
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>Curitiba</span>
                  </li> -->
                </ul>
              </div>
              <!-- <div class="col-6">
                <ul class="list list-1 list-icons">
                  <li>
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>Belo Horizonte</span>
                  </li>
                  <li>
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>Salvador</span>
                  </li>
                  <li>
                    <span class="icon icon-sm mdi mdi-map-marker"></span>
                    <span>Recife</span>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-creative-aside">
      <div class="container">
        <p class="rights"><span>Inversu</span><span>&nbsp;&copy;&nbsp;</span><span
            class="copyright-year"></span><span>&nbsp;</span><a href="privacy-policy.html">{{'final_texto' |
            transloco}}</a>
        </p>
      </div>
    </div>
  </footer>
</div>
